import { render, staticRenderFns } from "./SFXEditMetaData.vue?vue&type=template&id=2ff6a5f0&scoped=true&"
import script from "./SFXEditMetaData.vue?vue&type=script&lang=js&"
export * from "./SFXEditMetaData.vue?vue&type=script&lang=js&"
import style0 from "./SFXEditMetaData.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SFXEditMetaData.vue?vue&type=style&index=1&id=2ff6a5f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6a5f0",
  null
  
)

export default component.exports